import { render, staticRenderFns } from "./PageAsset.vue?vue&type=template&id=578a07cd&scoped=true&"
import script from "./PageAsset.vue?vue&type=script&lang=js&"
export * from "./PageAsset.vue?vue&type=script&lang=js&"
import style0 from "./PageAsset.vue?vue&type=style&index=0&id=578a07cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578a07cd",
  null
  
)

export default component.exports